const noop = () => null;

export const isClient = typeof window === "object";

export const isLocal =
  !isClient ||
  ["localhost", "127.0.0.1", "[::1]"].includes(location.hostname) ||
  location.hostname.includes("192.");

export const isClientDebug =
  isClient &&
  window.location &&
  window.location.href &&
  window.location.href.includes &&
  window.location.href.includes("debug=true");

const dev = {
  console:
    isLocal || isClientDebug ? console : { log: noop, warn: noop, error: noop },
};

export default dev;
